<script lang="ts">
    import { createEventDispatcher } from 'svelte'

    export let value: string = ''
    export let disabled = false
    export let required = false
    export let rows = undefined
    export let labeled = false
    export let htmlInput = null

    const dispatch = createEventDispatcher()

    function onKeyup(ev) {
        dispatch('keyup', ev)
    }
    function onChange(ev) {
        dispatch('change', ev)
    }
    function onFocus(ev) {
        dispatch('focus', ev)
    }
    function onBlur(ev) {
        dispatch('blur', ev)
    }
</script>

<textarea
    {required}
    bind:this={htmlInput}
    class="zinput_input zinput_input_labeled-{labeled}"
    bind:value
    {disabled}
    on:keyup={onKeyup}
    on:change={onChange}
    on:focus={onFocus}
    on:blur={onBlur}
    {rows}
></textarea>
